import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { requests } from "../../../common/RestAPI";
import { base64Encoding, getTimestampToDate } from "../../../common/util";
import { SESSIONSTORAGE, FONT } from "../../../value/staticValues";
import { PAGE_URL, PLATFORM_URL } from "../../../value/Url";
import { ALERTS, ERROR_CODE, POPUP_TYPE } from "../../../value/type";

import { ValidationError } from "../../../common/ExceptionError";

import { DetailProps } from "../../../interfaceTypes/ContentsProps";
import ProjectDetail from "./ProjectDetail";
import { t } from "i18next";
import { ProjectData, projectUpdateModalContent } from "./ProjectData";
import { DropdownType } from "../../base/CustomDropdown";



export interface ProjectQuota {
    projectQuotaId: string;
    vmMaxCount: number;
    vcpuMaxCount: number;
    memoryMaxCapacityGb: number;
    metadataMaxCount: number;
    keyPairMaxCount: number;
    vmPoolMaxCount: number;
    vmPoolMemberMaxCount: number;
    volumeMaxCount: number;
    volumeSnapshotMaxCount: number;
    volumeMaxCapacityGb: number;
    networkMaxCount: number;
    subnetMaxCount: number;
    portMaxCount: number;
    routerMaxCount: number;
    floatingIpMaxCount: number;
    securityGroupMaxCount: number;
    securityGroupRuleMaxCount: number;
    regionId: string;
    regionName: string;
}

export default function ProjectDetailContainter(props:DetailProps) {
    const [infoText, setInfoText] = useState('');
    const [infoError, setInfoError] = useState(false);

    const [targetId, setTargetId] = useState(props.targetId || '');
    const [projectQuotas, setProjectQuotas] = useState<ProjectQuota[]>([]);
    const [regions, setRegions] = useState<DropdownType[]>([]);
    const [detailData, setDetailData] = useState<ProjectData>();
    const [refreshYn, setRefreshYn] = useState(false);

    useEffect(() => {
        props.setLoading(false);
        AlertFunction('');
    }, []);


    function AlertFunction(text:string, error=false) {
        setInfoText(text);
        setInfoError(error);
    }

    useEffect(() => {
        if(!targetId) {
            const localTargetId = sessionStorage.getItem(SESSIONSTORAGE.PROJECT_TARGET_ID);
            if(localTargetId) {
                setTargetId(localTargetId);
            } else {
                // navigate(`${PAGE_URL.ERRORPAGE}`);
            }
        } else {
            sessionStorage.setItem(SESSIONSTORAGE.PROJECT_TARGET_ID, targetId);
        }
    }, [props]);


    useEffect(() => {
        if(targetId) {
            loadProject();
        }
    }, [targetId]);


    useEffect(() => {
        if(targetId && refreshYn) {
            loadProject();
        }
    }, [refreshYn]);


    function loadProject() {
        props.setLoading(true);
        requests.get(PLATFORM_URL.PROJECT + "/" + targetId)
        .then((response) => {
            if (response.status === 200 && response.data) {
                setDetailData(response.data);
            }
            props.setLoading(false);
            setRefreshYn(false);
        })
        .catch((_) => {
            props.setLoading(false);
            AlertFunction(t("MESSAGE_CANNOT_LOAD_DATA_MESSAGE"), true);
            setRefreshYn(false);
        });
    }


    function updateProjectResult(data) {
        if(data.successYn) {
            AlertFunction(t("MESSAGE_PROJECT_UPDATE_SUCCESS_MESSAGE"));
            setRefreshYn(true);
        }
    }

    function clickUpdate(item) {
        const data = {
            projectId: targetId,
            projectQuota: item
        }
        if(props.showSlideModalCb) {
            props.showSlideModalCb({...projectUpdateModalContent, openYn: true, resultCb: updateProjectResult, args: data});
        }
    }


    return (
        refreshYn === false?
            <ProjectDetail
                projectQuotas={projectQuotas}
                regions={regions}
                infoText={infoText}
                infoError={infoError}
                updateFunction={clickUpdate}
                detailData={detailData ? detailData : null}/>

            : null
    );
}
